import styled from 'styled-components';

export const Container = styled.div`
padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  .header {
    display: flex;
    justify-content: space-between;
    .texts {
      h3 {
        background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
        font-size: 32px;
        line-height: 44px;
        color: #1a237e;
      }
      p {
        margin-top: 5px;
        line-height: 22px;
        font-size: 16px;
        color: #667085;
      }
    }

    .link-buttons {
      display: flex;
      gap: 10px;
      .see-more,
      .add-campaign {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #344054;
        }
      }
      .add-campaign {
        a {
          color: #fff;
        }
        border: 1px solid #03a9f4;
        background-color: #03a9f4;
      }
    }
  }
`;

export const LayoutContainer = styled.div`
margin-top: 20px;
	.active {
        padding: 8px 48px;
        border-radius: 24px;
        background-color: #03a9f4;
		color: #fff;
	}
`;

export const TabContainer = styled.div`
	position: sticky;
	top: 0;
	background: #fff;
	z-index: 99;
`;

export const TabNavigationTab = styled.nav`
	padding: 15px 10px;
	overflow-x: scroll;

	ul {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}
	li {
		padding: 15px 2%;
        margin-right: 10px;
		display: inline;
		&:first-child {
			padding-left: 0;
		}
	}
	li a {
		color: #718096;
		padding: 14px 0;
		text-decoration: none;
	}
`;